// Nuevo módulo en Angular para instanciar los componentes que tiene el módulo de vacaciones.
// Se importa en app.module.ts

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { VacacionesComponent } from "./vacaciones.component";
import {
    RechazarVacacionesComponent,
    VacacionesFormComponent,
    ValidarVacacionesComponent,
} from "./vacaciones-form.component";
import { RouterModule } from "@angular/router";
import { SharedModule } from "../../../shared/shared.module";
import { EmployeeMultiSelectModule } from "../lista/employee-multi-select.module";

@NgModule({
    declarations: [
        VacacionesComponent,
        VacacionesFormComponent,
        ValidarVacacionesComponent,
        RechazarVacacionesComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatTableModule,
        MatTabsModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatDividerModule,
        MatDatepickerModule,
        MatCardModule,
        SharedModule,
        EmployeeMultiSelectModule,
    ],
    providers: []
})
export class VacacionesModule {}
